var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEuroSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35156 9.92969C7.32812 9.76562 7.16406 9.67188 7.02344 9.71875C6.78906 9.76562 6.41406 9.83594 5.99219 9.83594C4.09375 9.83594 2.66406 8.73438 2.21875 7H5.85156C5.99219 7 6.10938 6.90625 6.13281 6.78906L6.15625 6.60156C6.20312 6.41406 6.0625 6.25 5.89844 6.25H2.05469C2.00781 5.78125 2.00781 5.24219 2.07812 4.75H6.25C6.39062 4.75 6.50781 4.65625 6.53125 4.53906L6.57812 4.35156C6.60156 4.16406 6.46094 4 6.29688 4H2.24219C2.71094 2.35938 4.11719 1.1875 5.96875 1.1875C6.32031 1.1875 6.64844 1.23438 6.85938 1.28125C7 1.30469 7.14062 1.21094 7.1875 1.07031L7.28125 0.71875C7.30469 0.554688 7.21094 0.390625 7.04688 0.367188C6.8125 0.320312 6.4375 0.25 5.99219 0.25C3.60156 0.25 1.72656 1.86719 1.16406 4H0.53125C0.367188 4 0.25 4.14062 0.25 4.28125V4.46875C0.25 4.63281 0.367188 4.75 0.53125 4.75H1.02344C0.976562 5.17188 1 5.92188 1.02344 6.25H0.53125C0.367188 6.25 0.25 6.39062 0.25 6.53125V6.71875C0.25 6.88281 0.367188 7 0.53125 7H1.14062C1.63281 9.27344 3.50781 10.75 5.99219 10.75C6.50781 10.75 6.95312 10.6797 7.23438 10.6094C7.375 10.5859 7.46875 10.4219 7.44531 10.2812L7.35156 9.92969Z",
    fill: "#486175",
    className: "fill-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEuroSign);
export default __webpack_public_path__ + "static/media/ico-euro-sign.b9c1961fea1fab137e09ca65e22c44d9.svg";
export { ForwardRef as ReactComponent };